import { render, staticRenderFns } from "./FirstHeadSearch.vue?vue&type=template&id=f244b890&scoped=true&"
import script from "./FirstHeadSearch.vue?vue&type=script&lang=js&"
export * from "./FirstHeadSearch.vue?vue&type=script&lang=js&"
import style0 from "./FirstHeadSearch.vue?vue&type=style&index=0&id=f244b890&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f244b890",
  null
  
)

export default component.exports